export default __webpack_public_path__ + "static/media/avatar_ali1.d252d44d.mp3";